export default {
  title: 'Synchronizacja marki — Marki',
  subtitle:
    'Przegląd wszystkich restauracji w grupie i ich zsynchronizowanych funkcji. Tylko administrator konta może wprowadzać zmiany.',
  alert: {
    message: 'Dostęp tylko dla administratora',
    description:
      'Zmiany w menu głównym, cenach i ofertach może wprowadzać tylko administrator konta. Wszystkie lokalizacje otrzymują aktualizacje automatycznie.',
  },
  locations: {
    title: 'Lokalizacje',
    description: 'Wszystkie restauracje w grupie współdzielące menu główne i ustawienia',
    locations_zero: '0 lokalizacji',
    locations_one: '1 lokalizacja',
    locations_few: '{{count}} lokalizacje',
    locations_many: '{{count}} lokalizacji',
    locations_other: '{{count}} lokalizacji',
    synced: 'Zsynchronizowane',
  },
  features: {
    title: 'Zsynchronizowane funkcje',
    description: 'Te funkcje są kontrolowane przez ustawienia główne',
    menus: {
      title: 'Menu główne',
      desription: 'Pozycje menu, kategorie i opisy są synchronizowane we wszystkich lokalizacjach',
    },
    smart_pricing: {
      title: 'Inteligentne ceny',
      desription: 'Reguły cenowe i korekty są synchronizowane we wszystkich lokalizacjach',
    },
    offers: {
      title: 'Oferty i promocje',
      desription: 'Aktywne oferty, rabaty i promocje są synchronizowane we wszystkich lokalizacjach',
    },
  },
};
